// your-component.ts
import { Component, Input } from '@angular/core';

@Component({
  selector: 'pick-list-total',
  templateUrl: './pick-list-total.component.html',
  styleUrls: ['./pick-list-total.component.scss'],
})
export class PickListTotalComponent {
  // Assuming you have 'sku' object in the component with 'active_picklist_items' property
  @Input() picklistItems ?:any[];

  getTotalQuantityAndIncrement() :number {
    let totalQuantity = 0;
    const items = this.picklistItems;
    if (items) {
      for (const item of items) {
        totalQuantity += item.available_quantity;
      }
    }

    return totalQuantity;
  }
}
